import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import axiosClient from "../api/axiosClient";
import { useEffect, useState } from "react";
import { logout, selectStaffAccessToken } from "../redux/staffSlice";

export default function ProtectedRoute({ children }) {
  const dispatch = useDispatch();
  const token = useSelector(selectStaffAccessToken);
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setIsValid(false);
        return;
      }
      try {
        await axiosClient.post("/token/verify/", { token });
        setIsValid(true);
      } catch {
        dispatch(logout());
        setIsValid(false);
      }
    };
    verifyToken();
  }, [dispatch, token]);

  if (isValid === null) return null; // ou un loader

  if (!isValid) {
    return <Navigate to="/login" replace />;
  }

  return children;
}